export const erpIntegrationKeys = {
  all: ['erpIntegration'] as const,
  // Company-scoped: the key must carry companyId — there is no cache reset on
  // company switch, so the key is the only isolation.
  connections: (companyId: string) => [...erpIntegrationKeys.all, 'connections', companyId] as const,
  ftpConnection: (companyId: string) => [...erpIntegrationKeys.all, 'ftpConnection', companyId] as const,
  erpCompanies: (companyId: string | null, erpType?: string) =>
    [...erpIntegrationKeys.all, 'erpCompanies', companyId, erpType] as const,
  hashDevices: (companyId: string) => [...erpIntegrationKeys.all, 'hashDevices', companyId] as const,
  zohoOrganizations: (companyId: string) => [...erpIntegrationKeys.all, 'zohoOrganizations', companyId] as const,
  preferenceFields: (companyId: string) => [...erpIntegrationKeys.all, 'preferenceFields', companyId] as const,
  preferenceFieldsOf: (companyId: string, erp: string) =>
    [...erpIntegrationKeys.preferenceFields(companyId), erp] as const,
};
